import SpinnerChase from './SpinnerChase';

type TPreloader = {
  className?: string;
}

const Preloader = (props: TPreloader) => {

  return <div id="preloader" className={props.className}>
    <div id="status">
      <SpinnerChase />
    </div>
  </div>;
}

export default Preloader;